function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MapService = /*#__PURE__*/function () {
  function MapService() {
    _classCallCheck(this, MapService);
  }
  return _createClass(MapService, [{
    key: "construct",
    value: function construct($canvas, settings) {}
  }, {
    key: "setType",
    value: function setType(type) {}
  }, {
    key: "getCenter",
    value: function getCenter() {}
  }, {
    key: "setCenter",
    value: function setCenter(center) {}
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {}
  }, {
    key: "getZoom",
    value: function getZoom() {}
  }, {
    key: "addPins",
    value: function addPins(pins) {}
  }, {
    key: "geocode",
    value: function geocode(query) {
      var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    }
  }, {
    key: "getPinsWithinRange",
    value: function getPinsWithinRange(lat, lng, rangeInMeters) {}
  }, {
    key: "getPinClosestTo",
    value: function getPinClosestTo(lat, lng) {}
  }, {
    key: "getPinDistance",
    value: function getPinDistance(lat, lng, pin) {}
  }, {
    key: "highlightPin",
    value: function highlightPin(pin) {}
  }, {
    key: "fitPins",
    value: function fitPins(pins) {}
  }, {
    key: "updatePinVisibility",
    value: function updatePinVisibility(pin) {}
  }, {
    key: "locate",
    value: function locate() {}
  }, {
    key: "redraw",
    value: function redraw() {}
  }]);
}();
;
module.exports = MapService;